import { API_URL } from "../constants";
import { setURLState, deleteURLState } from "../functions/urlstate";

export const addArea = (key, history, location, updateurl) => {
    return (dispatch, getState) => {

      // Update URL with added area

      if (updateurl) setURLState({'a': key}, history, location);

      // Retrieve data for area from server

      const headers = {"Content-Type": "application/json"};      
      const global = getState().global;
      const body = JSON.stringify({ periodstart: global.periodstart, periodend: global.periodend, area: key });

      return fetch(API_URL + "/data/", {headers, method: "POST", body})
        .then(res => {
          if (res.status < 500) {
            return res.json().then(data => {
              return {status: res.status, data};
            })
          } else {
            console.log("Server Error!");
            throw res;
          }
        })
        .then(res => {
          if (res.status === 200) {
            return dispatch({type: 'ADD_AREA', key: key, area: res.data.area, data: res.data.data});
          } else {
            throw res;
          }
        });
    }
}


export const updateArea = (key) => {
  return (dispatch, getState) => {

    // Retrieve data for area from server

    const headers = {"Content-Type": "application/json"};      
    const global = getState().global;
    const body = JSON.stringify({ periodstart: global.periodstart, periodend: global.periodend, area: key });
    
    return fetch(API_URL + "/data/", {headers, method: "POST", body})
      .then(res => {
        if (res.status < 500) {
          return res.json().then(data => {
            return {status: res.status, data};
          })
        } else {
          console.log("Server Error!");
          throw res;
        }
      })
      .then(res => {
        if (res.status === 200) {
          return dispatch({type: 'UPDATE_AREA', key: key, data: res.data.data});
        } else {
          throw res;
        }
      });
  }
}


export const deleteArea = (key, history, location) => {
    return (dispatch, getState) => {

      // Update URL with deleted area

      deleteURLState({'a': key}, history, location);

      // Dispatch DELETE_AREA

      dispatch({type: 'DELETE_AREA', key: key});
      return Promise.resolve(true);
    }
}

export const resetMaxValue = () => {
  return (dispatch, getState) => {
    dispatch({type: 'RESET_MAX_VALUE'});
    return Promise.resolve(true);
  }
}
